<template xmlns="http://www.w3.org/1999/html">
  <b-container id="annonce-create-container" class="d-flex flex-column">
    <div id="annonce-create-title-container" class="row pt-md-3 pt-2">
      <div class="col-12 col-md-6 d-flex justify-content-center">
        <div class="custom-width ml-md-5 justify-content-between d-md-flex align-items-center">
          <back-arrow :confirm="currentStep > getStepIndex('ONBOARDING')" :title="$t('annonce.Create')"
                      :title-modal="$t('annonce.leave.page.ask')"/>
        </div>
      </div>

      <div
        v-if="currentStep > getStepIndex('VEHICLE_TYPE') && currentStep < getStepIndex('RECAP') && this.annonce.status !== 'TO_VALIDATE'"
        class="col-12 col-md-6 d-flex justify-content-start">
        <div class=" w-100 d-md-flex align-items-center justify-content-center d-none">
          <i v-if="!saved&&!notSaved"
             class="ph-custom ph-floppy-disk cursor-pointer d-none d-md-block"
             @click="saveDraft"/>
          <i v-else-if="saved"
             class="ph-custom ph-check d-none d-md-block main-green-color"/>
          <i v-else-if="notSaved"
             class="ph-custom ph-warning d-none d-md-block main-red-color"/>
          <span :class="{'main-green-color': saved, 'main-red-color': notSaved, 'cursor-pointer': !saved && !notSaved}"
                class="pl-2"
                @click="saveDraft">{{
              saved ? $t('annonce.saved.Draft') : (notSaved ? $t('annonce.notSaved.Draft') : $t('annonce.save.Draft'))
            }}</span>
        </div>
      </div>
    </div>

    <annonce-create-step0
      v-if="getStepCondition('ONBOARDING')"
      @setMaxStep="setMaxStep">
    </annonce-create-step0>

    <div v-if="currentStep > getStepIndex('ONBOARDING')" id="annonce-create-sub-container" class="row pt-md-5 pt-2">
      <div id="annonce-create-sub-container-left" class="col-12 col-md-6 col-title">
        <div class="custom-width ml-md-5 d-flex align-items-center">
          <h1 v-if="getStepCondition('RECAP')" class="page-title w-75">
            {{ $t('annonce.recap.annonce.title') }}</h1>
          <h1 v-else-if="getStepCondition('ADDITIONNAL_REWARD')" class="page-title w-75">
            {{ $t('annonce.create.additional.reward.page.title') }}</h1>
          <h1 v-else-if="getStepCondition('PAYMENT_SUMMARY')" class="page-title w-75">
            {{ $t('payment.summary.page.title') }}</h1>
          <h1 v-else class="page-title w-75">{{ $t('annonce.Declare') }}</h1>
          <i v-if="currentStep<getStepIndex('RECAP')&&!saved&&!notSaved&&this.annonce.status!=='TO_VALIDATE'"
             class="ph-custom ph-floppy-disk cursor ml-auto save-draft-icon-mobile d-block d-md-none"
             @click="saveDraft"/>
          <i v-if="currentStep<getStepIndex('RECAP')&&saved"
             class="ph-custom ph-floppy-disk cursor ml-auto save-draft-icon-mobile d-block d-md-none main-green-color"/>
          <i v-if="currentStep<getStepIndex('RECAP')&&notSaved"
             class="ph-custom ph-warning-diamond cursor ml-auto save-draft-icon-mobile d-block d-md-none main-red-color"/>
        </div>

        <div v-if="getStepCondition('VEHICLE_TYPE')" class="custom-width ml-md-5 mt-3"><h1 class="content">
          {{ $t('annonce.typeof.vehicle') }}</h1></div>
        <div v-if="getStepCondition('BRAND')" class="custom-width ml-md-5 mt-3"><h1 class="content">
          {{ $t('annonce.typeof.brand') }}</h1></div>
        <div v-if="getStepCondition('MODEL')" class="custom-width ml-md-5 mt-3"><h1 class="content">
          {{ $t('annonce.typeof.model') }}</h1></div>
        <div v-if="getStepCondition('MANDATORY_FIELDS')" class="custom-width ml-md-5 mt-3"><h1 class="content">
          {{ $t('annonce.vehicle.more.informations') }}</h1></div>
        <div v-if="getStepCondition('ADDITIONNAL_FIELDS')" class="custom-width ml-md-5 mt-3"><h1 class="content">
          {{ $t('annonce.vehicle.more.informations') }}</h1></div>
        <div v-if="getStepCondition('PHOTOS')" class="custom-width ml-md-5 mt-3"><h1 class="content">
          {{ $t('annonce.vehicle.more.images') }}</h1></div>
        <div v-if="getStepCondition('PAPERS')"
             class="custom-width ml-md-5 mt-3"><h1 class="content">
          {{ $t('annonce.vehicle.more.informations.identity') }}</h1></div>

        <div v-if="getStepCondition('ADDITIONNAL_REWARD')" class="custom-width ml-md-5 mt-3">
          <span class="bold-text">{{ $t('annonce.create.additional.reward.title') }}</span></div>
        <div v-if="getStepCondition('ADDITIONNAL_REWARD')" class="custom-width ml-md-5 mt-3">
          <h1 class="content">{{ $t('annonce.create.additional.reward.description') }}</h1></div>
        <div v-if="getStepCondition('ADDITIONNAL_REWARD')" class="custom-width ml-md-5 mt-3">
          <p class="link-main-color cursor-pointer" @click="$bvModal.show('additional-reward-info-modal')">
            {{ $t('annonce.create.additional.reward.know.more') }}</p></div>

        <div v-if="getStepCondition('RECAP')" class="custom-width ml-md-5 mt-3">
          <h1 class="content">
            {{ $t('annonce.Recap.annonce.subtitle') }}</h1></div>
        <div v-if="getStepCondition('RECAP')" class="custom-width ml-md-5 mt-3"><span
          class="bold-text">{{ $t('annonce.Recap.annonce.tip.Add') }}</span></div>

        <div v-if="getStepCondition('PAYMENT_SUMMARY')" class="custom-width ml-md-5 mt-3">
          <h1 class="content">{{ $t('payment.summary.page.description') }}</h1></div>
        <PaymentSummaryTotalCard
          v-if="getStepCondition('PAYMENT_SUMMARY')"
          :annonces="annonces"
          class="custom-width ml-md-5 mt-3"
          @setTotalToPay="setTotalToPay"
        ></PaymentSummaryTotalCard>

      </div>

      <div id="annonce-create-sub-container-right"
           class="col-12 col-md-6 d-flex justify-content-center justify-content-md-start">

        <annonce-create-step1
          v-if="getStepCondition('VEHICLE_TYPE')"
          :annonce="this.annonce"
          @updateAnnonce="updateAnnonce">
        </annonce-create-step1>

        <annonce-create-step2
          v-if="getStepCondition('BRAND')"
          :annonce="this.annonce"
          @updateAnnonce="updateAnnonce">
        </annonce-create-step2>

        <annonce-create-step3
          v-if="getStepCondition('MODEL')"
          :annonce="this.annonce"
          @updateAnnonce="updateAnnonce">
        </annonce-create-step3>

        <annonce-create-step4
          v-if="getStepCondition('MANDATORY_FIELDS')"
          :annonce="this.annonce"
          :hasBicycode="hasBicycode"
          :hasSerialNumber="hasSerialNumber"
          :hasVIN="hasVIN"
          :isLicensed="isLicensed"
          @updateAnnonce="updateAnnonce">
        </annonce-create-step4>

        <annonce-create-step5
          v-if="getStepCondition('ADDITIONNAL_FIELDS')"
          :annonce="this.annonce"
          :has-window-engraving-vehicle-type="hasWindowEngraving"
          :hasVIN="hasVIN"
          :isLicensed="isLicensed"
          @updateAnnonce="updateAnnonce">
        </annonce-create-step5>

        <annonce-create-step6
          v-if="getStepCondition('PHOTOS')"
          :annonce="this.annonce"
          @updateAnnonce="updateAnnonce">
        </annonce-create-step6>

        <annonce-create-step7
          v-if="getStepCondition('PAPERS')"
          :annonce="this.annonce"
          :isLicensed="isLicensed"
          @updateAnnonce="updateAnnonce">
        </annonce-create-step7>

        <annonce-create-additional-reward-step
          v-if="getStepCondition('ADDITIONNAL_REWARD')"
          :annonce="this.annonce"
          :fromAnnonceCreation="true"
          @updateAnnonce="updateAnnonce"
        ></annonce-create-additional-reward-step>

        <annonce-create-recap-step
          v-if="getStepCondition('RECAP')"
          :annonces="this.annonces"
          :annonces-saved="this.annoncesSaved"
          @addDraft="addDraft"
          @addNewAnnonce="addNewAnnonce"
          @editAnnonce="editAnnonce"
          @removeAnnonce="removeAnnonce">
        </annonce-create-recap-step>

        <AnnonceCreatePaymentSummaryStep
          v-if="getStepCondition('PAYMENT_SUMMARY')"
          :annonces="this.annonces"
        ></AnnonceCreatePaymentSummaryStep>

      </div>
    </div>


    <div v-if="currentStep > getStepIndex('ONBOARDING')" class="footer-create-annonce">
      <span class="fixed-bottom-100px span-step d-none d-md-block">{{
          $t('register.Step') + " " + currentStep + '/' + maxStep
        }}</span>
      <b-progress :max="maxStep" :value="currentStep" class="custom-progress-bar-no-radius" height="1em"
                  variant="primary"></b-progress>
      <div class="row h-100">
        <div class="col-md-12  d-flex align-items-center mb-2 ml-2 mr-2 justify-content-around">
          <b-button
            v-if="!hasPaid"
            ref="btnPrevStep"
            :disabled="(getStepCondition('RECAP') || (getStepCondition('MANDATORY_FIELDS') && this.lockPreviousButton))"
            class="mr-1" variant="secondary"
            @click="prevStep"
          >
            <div class="pr-3 pl-3">{{ currentStep > getStepIndex('VEHICLE_TYPE') ? $t('Previous') : $t('Back') }}</div>
          </b-button>
          <!-- btn inactif et caché pour garder le btn publier au même endroit que le bouton suivant entre l'avant-dernière étape et l'étape de récap -->
          <!--          <b-button v-if="currentStep===maxStep" class="mr-1" disabled variant="hidden-black">-->
          <!--            <div class="pr-3 pl-3">{{ $t('Previous') }}</div>-->
          <!--          </b-button>-->
          <span class="span-step d-block d-md-none ">{{ currentStep + ' / ' + maxStep }}</span>
          <div v-if="currentStep>getStepIndex('MANDATORY_FIELDS') && currentStep <getStepIndex('RECAP')"
               class="custom-span-data"
          ><span v-html="$t('annonce.enough.data')"></span></div>
          <b-button
            v-if="!hasPaid"
            ref="btnNextStep" :disabled="(getStepCondition('RECAP') && annonces.length === 0)" class="mr-1"
            variant="primary"
            @click="nextStep">
            <div v-if="!isPublishing && !isLoading" class="pr-4 pl-4">
              {{ buttonTitlePublishOrNext ? $t('Publish') : $t('Next') }}
            </div>
            <b-spinner v-else class="button-spinner"></b-spinner>
          </b-button>
        </div>
      </div>
    </div>

    <annonce-incomplete-modal
      :annonce="annonce"
      @checkedNotif="updateAnnonce"
      @complete="handleCompleteIncompleteAnnonce"
      @publish="publishIncompleteAnnonce"
    ></annonce-incomplete-modal>

    <annonce-online-modal
      :annonces="annonces"
    ></annonce-online-modal>
    <annonce-pro-modal @okProModal="okProModal"></annonce-pro-modal>

    <StripePaymentModal
      :client-secret="stripeClientSecret"
      :total="this.totalToPay"
      redirect-url="/annonce/validateStripeIntentForBankImprint"
      @closedStripePaymentModal="closedStripePaymentModal"
      @validatePayment="handlePostPaymentSuccess"
    ></StripePaymentModal>

  </b-container>

</template>

<script>
import BackArrow from "../../../components/b122/BackArrow";
import api from "../../../services/api";
import i18n from "../../../i18n";
import AnnonceCreateStep0 from "./AnnonceCreateStep0";
import AnnonceCreateStep1 from "./AnnonceCreateStep1";
import AnnonceCreateStep2 from "./AnnonceCreateStep2";
import AnnonceCreateStep3 from "./AnnonceCreateStep3";
import AnnonceCreateStep4 from "./AnnonceCreateStep4";
import AnnonceCreateStep5 from "./AnnonceCreateStep5";
import AnnonceCreateStep6 from "./AnnonceCreateStep6";
import AnnonceCreateStep7 from "./AnnonceCreateStep7";
import AnnonceIncompleteModal from "../AnnonceIncompleteModal";
import AnnonceCreateAdditionalRewardStep from "./AnnonceCreateAdditionalRewardStep";
import AnnonceCreateRecapStep from "./AnnonceCreateRecapStep"
import PaymentSummaryTotalCard from "../../../components/annonce/PaymentSummaryTotalCard";
import StripePaymentModal from "../../../components/annonce/StripePaymentModal";
import AnnonceCreatePaymentSummaryStep from "./AnnonceCreatePaymentSummaryStep";
import AnnonceOnlineModal from "../../../components/annonce/AnnonceOnlineModal";
import AnnonceProModal from "../../../components/annonce/AnnonceProModal";
import Vue from "vue";
import AnnonceCreationUtils from "../../../utils/AnnonceCreationUtils";

export default {
  name: "AnnonceCreate",

  components: {
    BackArrow,
    AnnonceCreateStep0,
    AnnonceCreateStep1,
    AnnonceCreateStep2,
    AnnonceCreateStep3,
    AnnonceCreateStep4,
    AnnonceCreateStep5,
    AnnonceCreateStep6,
    AnnonceCreateStep7,
    AnnonceIncompleteModal,
    AnnonceCreateAdditionalRewardStep,
    AnnonceCreateRecapStep,
    PaymentSummaryTotalCard,
    AnnonceCreatePaymentSummaryStep,
    AnnonceOnlineModal,
    AnnonceProModal,
    StripePaymentModal,
  },

  data() {
    return {
      AnnonceCreationUtils: AnnonceCreationUtils,

      annonceId: this.$route.params.annonceId,
      annonceToEdit: {},
      isPublishing: false,
      isLoading: false,
      isCreatingFastAnnonce: false,
      annonces: [],
      annoncesFailedToSave: [],
      annoncesSaved: [],
      annonceIds: [],
      saved: false,
      notSaved: false,
      hasError: false,
      skipReset: false,
      maxStep: 0,
      currentStep: 0,
      isLicensed: null,
      hasBicycode: null,
      hasSerialNumber: null,
      hasWindowEngraving: null,
      hasVIN: null,
      annonce: this.initAnnonce(),
      lockPreviousButton: false,
      skipRecap: false,

      //PAYMENT
      totalToPay: 0,
      hasPaid: false,
      stripeIntentId: "",
      stripeClientSecret: "",
    }
  },

  watch: {
    'annonce.vehicleType.value': {
      immediate: true,
      handler() {
        if (this.skipReset) return;

        if (this.annonce.vehicleType.value) {
          this.fetchVehicleTypeInfo();
          this.resetFields(['vehicleType', 'id', 'isFastAnnonce', 'isLicensed']);
        } else {
          this.isLicensed = null;
          this.hasBicycode = null;
          this.hasSerialNumber = null;
          this.hasWindowEngraving = null;
          this.hasVIN = null;
        }
        this.vehicleFiles = [];
      }
    },

    'annonce.brand.value'(newVal, oldVal) {
      if (this.skipReset) return;
      if (newVal !== oldVal) {
        this.resetFields(['vehicleType', 'brand', 'id', 'isFastAnnonce', 'isLicensed']);
      }
    },

    'annonce.model.value'(newVal, oldVal) {
      if (this.skipReset) {
        this.skipReset = false
        return
      }
      if (newVal !== oldVal) {
        this.resetFields(['vehicleType', 'brand', 'model', 'id', 'isFastAnnonce', 'isLicensed']);
      }
    },
  },

  async mounted() {
    if (this.annonceId) {
      await this.fetchAnnonce()
    }
    window.addEventListener('beforeunload', this.beforeUnloadHandler);
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeUnloadHandler);
  },

  computed: {
    buttonTitlePublishOrNext() {
      if (!this.annonce.id && this.currentStep === this.getStepIndex('PAYMENT_SUMMARY')) {
        return true
      }
      if (this.annonce.id && this.annonce.status !== "TO_VALIDATE" && this.currentStep === this.getStepIndex('PAYMENT_SUMMARY')) {
        return true
      }
      if (this.annonce.id && this.annonce.status === "DRAFT" && this.currentStep === this.maxStep && this.annonce.hasOwnProperty('hasActiveStripeIntent') && this.annonce.hasActiveStripeIntent) {
        return true
      }
      if (this.annonce.id && this.annonce.status == "TO_VALIDATE" && this.currentStep == this.maxStep) {
        return true
      }
      return false
    }
  },

  methods: {

    beforeUnloadHandler(event) {
      event.preventDefault();
      event.returnValue = '';
    },

    //region step
    getStep(step) {
      return AnnonceCreationUtils.steps()[step]
    },

    getStepByIndex(index) {
      for (const [key, value] of Object.entries(AnnonceCreationUtils.steps())) {
        if (this.isCreatingFastAnnonce && value.fastStep === index) {
          return key
        } else if (!this.isCreatingFastAnnonce && value.compStep === index) {
          return key
        }
      }
      return 'VEHICLE_TYPE'
    },

    getStepIndex(step) {
      let actualStep = this.getStep(step)
      if (actualStep === undefined) {
        actualStep = this.getStep('ONBOARDING')
      }
      if (this.isCreatingFastAnnonce) {
        return actualStep.fastStep
      } else {
        return actualStep.compStep
      }
    },

    getStepCondition(step) {
      return this.currentStep === this.getStepIndex(step)
    },

    async nextStep() {
      this.hasError = this.checkForErrors(this.annonce)
      if (this.$refs.btnNextStep) {
        this.$refs.btnNextStep.blur()
      }
      if (this.isLoading || this.isPublishing) {
        return
      }
      if (this.currentStep === 0) {
        this.currentStep++
      } else if (this.buttonTitlePublishOrNext && this.currentStep !== this.getStepIndex('PAYMENT_SUMMARY') && !this.hasError) {
        this.isLoading = true
        await this.handleSubmit()
      } else if (this.currentStep < this.getStepIndex('RECAP') && !this.hasError) {
        this.isLoading = true
        await this.handleSubmit()
      } else if (this.getStepCondition('RECAP') && this.annonces.length > 0 && !this.hasError) {
        this.currentStep++
      } else if (this.currentStep === this.getStepIndex('PAYMENT_SUMMARY') && !this.hasError) {
        this.isLoading = true
        this.isPublishing = true
        await this.requestStripePaymentIntent()
      }
    },

    prevStep() {
      if (this.$refs.btnPrevStep) {
        this.$refs.btnPrevStep.blur()
      }
      if (this.isLoading || this.isPublishing) {
        return
      }
      if (this.getStepCondition('RECAP')) {
        this.skipReset = true
        this.annonce = JSON.parse(JSON.stringify(this.annonces.pop()))
      }
      if (this.getStepCondition('PAYMENT_SUMMARY') && this.hasPaid) {
        return
      }
      if (this.getStepCondition('VEHICLE_TYPE') && this.annonceId) {
        this.$router.push({
          name: 'AnnonceShow',
          params: {annonceId: this.annonceId}
        })
      }
      if (this.currentStep > 0) {
        this.currentStep--
      } else {
        this.$router.push({
          name: 'Home',
        })
      }
    },

    goToStep(step) {
      if (this.isLoading || this.isPublishing) {
        return
      }
      let stepIndex = this.getStepIndex(step)
      if (stepIndex < 1 || stepIndex >= this.getStepIndex('RECAP')) {
        return
      }
      this.currentStep = stepIndex
    },

    setMaxStep(creationType) {
      if (creationType === 'fast') {
        this.isCreatingFastAnnonce = true;
        this.maxStep = AnnonceCreationUtils.fastAnnonceMaxStep(null)
      } else {
        this.isCreatingFastAnnonce = false;
        this.maxStep = AnnonceCreationUtils.completeAnnonceMaxStep(null)
      }
      if (this.currentStep === 0) {
        this.annonces = []
        this.annoncesFailedToSave = []
        this.annoncesSaved = []
        this.annonceIds = []
        this.annonce = this.initAnnonce()
        this.$bvModal.show('annonce-pro-modal')
      } else {
        this.nextStep()
      }
    },
    //endregion

    //region creation
    fetchVehicleTypeInfo() {
      api
        .get(`/vehicleType/getInfoVehicleType/${this.annonce.vehicleType.value}`)
        .then(response => {
          this.isLicensed = response.data.isLicensed
          this.hasBicycode = response.data.hasBicycode
          this.hasSerialNumber = response.data.hasSerialNumber
          this.hasVIN = response.data.hasVIN
          this.hasWindowEngraving = response.data.hasWindowEngraving
        })
    },

    okProModal() {
      this.nextStep()
    },

    updateVehicleType(vehicleType) {
      this.annonce.vehicleType.value = vehicleType
    },

    updateAnnonce(annonce) {
      const id = this.annonce.id;
      this.annonce = Object.assign({}, annonce);
      if (id) {
        this.annonce.id = id;
      }
    },

    resetFields(excludeFields = []) {
      const defaultState = {
        state: null,
        invalidFeedback: null,
        value: null,
        fileName: ""
      };

      Object.keys(this.annonce).forEach(field => {
        if (!excludeFields.includes(field)) {
          if (typeof this.annonce[field] === 'object' && this.annonce[field] !== null && !Array.isArray(this.annonce[field])) {
            Vue.set(this.annonce, field, {...defaultState});
          } else if (!Array.isArray(this.annonce[field])) {
            Vue.set(this.annonce, field, typeof this.annonce[field] === 'object' ? [] : null);
          }
        }
      });

      // Ensure the id field is retained if it exists
      if (this.annonce.id && excludeFields.includes('id')) {
        Vue.set(this.annonce, 'id', this.annonce.id);
      }

    },

    async handleSubmit(fromUserInput, forceDraft = false) {
      if (this.getStepCondition('MANDATORY_FIELDS') && !fromUserInput) {
        //D'abord on force la vérification
        await this.sendAnnonce(this.annonce, false, true, false, forceDraft)
        if (!this.hasError) {
          if (this.isComplete(this.annonce)) {
            //Ensuite on enregistre et on passe à l'étape suivante
            await this.sendAnnonce(this.annonce, true, false, true, forceDraft)
          } else if (!this.isComplete(this.annonce) && this.isCreatingFastAnnonce) {
            this.isLoading = false
            this.$bvModal.show('annonce-incomplete-modal')
          } else {
            await this.sendAnnonce(this.annonce, fromUserInput, false, false, forceDraft)
          }
        }
      } else {
        if (this.getStepCondition('PAPERS') && !this.isComplete(this.annonce)) {
          this.isLoading = false
          this.$bvModal.show('annonce-incomplete-modal')
        } else {
          await this.sendAnnonce(this.annonce, fromUserInput, false, false, forceDraft)
        }
      }

      this.isLoading = false
    },

    async publishIncompleteAnnonce(annonce) {
      this.updateAnnonce(annonce)
      await this.sendAnnonce(this.annonce, true, false, true, false)
      this.$bvModal.hide('annonce-incomplete-modal')
      this.isLoading = false
    },

    async handleCompleteIncompleteAnnonce() {
      if (this.getStepCondition('MANDATORY_FIELDS') && this.isCreatingFastAnnonce) {
        this.isCreatingFastAnnonce = false
        this.annonce.isFastAnnonce = false
        this.maxStep = AnnonceCreationUtils.completeAnnonceMaxStep(this.annonce)
        await this.sendAnnonce(this.annonce, false, false, true, false)
        this.$bvModal.hide('annonce-incomplete-modal')
        this.isLoading = false
      } else {
        this.$bvModal.hide('annonce-incomplete-modal')
        this.isLoading = false
      }
    },

    checkForErrors(annonce) {
      const currentStep = this.getStepByIndex(this.currentStep);
      const fieldsToCheck = this.AnnonceCreationUtils.stepFields()[currentStep] || [];
      let hasError = false;

      fieldsToCheck.forEach((key) => {
        if (annonce[key] && annonce[key].state === false) {
          hasError = true;
        }
      });

      return hasError;
    },

    async sendAnnonce(annonce, fromUserInput, justCheckValidity = false, forceNextStep = false, forceDraft = false) {


      const annonceData = Object.keys(annonce).reduce((acc, key) => {
        if (annonce[key] && annonce[key].value !== null) {
          acc[key] = annonce[key].value
        }
        return acc
      }, {});

      let isDraft = annonce.status !== "TO_VALIDATE"

      let formData = new FormData()
      formData.append('annonce', JSON.stringify(annonceData))
      formData.append('annonceId', annonce.id)
      formData.append('isDraft', isDraft)
      formData.append('isFastAnnonce', annonce.isFastAnnonce)
      formData.append('currentStep', this.getStepByIndex(this.currentStep))
      formData.append('identityRecto', annonce.identityRecto.value)
      formData.append('identityRectoId', annonce.identityRecto.id)
      formData.append('identityVerso', annonce.identityVerso.value)
      formData.append('identityVersoId', annonce.identityVerso.id)
      formData.append('carteGriseFile', annonce.carteGriseFile.value)
      formData.append('carteGriseFileId', annonce.carteGriseFile.id)
      formData.append('plainteFile', annonce.plainteFile.value)
      formData.append('plainteFileId', annonce.plainteFile.id)
      formData.append('assuranceFile', annonce.assuranceFile.value)
      formData.append('assuranceFileId', annonce.assuranceFile.id)
      formData.append('nbImagesVehicle', annonce.vehicleFiles.length)
      formData.append('additionnalRewardLevel', annonce.additionnalRewardLevel.value)
      formData.append('additionnalRewardAmount', annonce.additionnalRewardAmount.value)
      formData.append('forceDraft', forceDraft)
      annonce.vehicleFiles.forEach((file, index) => {
        formData.append(`imagesVehicle[${index}]`, file.file)
        formData.append(`imagesVehicleId[${index}]`, file.id)
      });
      let imagesVehicleIds = annonce.vehicleFiles.filter(file => file.id).map(file => file.id).join(',')
      if (imagesVehicleIds) {
        formData.append('imagesVehicleIds', imagesVehicleIds)
      }
      formData.append('needsReminderNotification', annonce.needsReminderNotification)

      //On check si l'annonce est complète
      Vue.set(this.annonce, "isComplete", this.isComplete(annonce));

      await api({
        method: 'POST',
        url: (this.currentStep <= this.getStepIndex('MANDATORY_FIELDS') && isDraft && !fromUserInput) ? `/annonce/checkStepBeforeSave` : `/annonce/saveAnnonceGrandPublic`,
        data: formData
      })
        .then((response) => {
          this.hasError = false
          if (!justCheckValidity) {
            if (fromUserInput && !forceNextStep) {
              // On a appuyé sur la disquette de sauvegarde
              Vue.set(this.annonce, 'id', response.data.id)
              this.saved = true
              setTimeout(() => {
                this.saved = false
              }, 2000);
            } else if (this.currentStep === (this.getStepIndex('RECAP') - 1)
              && (this.maxStep === AnnonceCreationUtils.fastAnnonceMaxStep(this.annonce) || this.maxStep === AnnonceCreationUtils.completeAnnonceMaxStep(this.annonce))
            ) {
              //Si on est à la dernière étape de la création ET qu'on est pas en EDIT d'une annonce TO_VALIDATE
              this.annonces.push({...annonce, maxStep: this.maxStep});
              this.annonce = this.initAnnonce()
              this.currentStep++
            } else if (this.getStepCondition('RECAP')) {
              this.annoncesSaved.push({...annonce, id: response.data.id})
              this.annonceIds.push(response.data.id)
            } else {
              if (response.data.id) {
                Vue.set(this.annonce, 'id', response.data.id)
              }
              if (this.currentStep < this.maxStep) {
                this.currentStep++
              } else {
                if (this.annonce.status === "TO_VALIDATE" && this.annonce.id && this.buttonTitlePublishOrNext) {
                  this.annonces.push({...annonce, maxStep: this.maxStep, id: response.data.id});
                  this.$bvModal.show('annonce-online-modal')
                }
                if (this.annonce.status === "DRAFT" && this.annonce.id && this.buttonTitlePublishOrNext && this.annonce.hasActiveStripeIntent) {
                  this.annonces.push({...annonce, maxStep: this.maxStep, id: response.data.id});
                  this.$bvModal.show('annonce-online-modal')
                }
              }
            }
          }

        })
        .catch(error => {
          this.hasError = true
          if (!error.response) {
            console.log("error", error)
          }

          if (isDraft) {
            if (forceDraft) {
              this.notSaved = true
              setTimeout(() => {
                this.notSaved = false
              }, 2000);
            }
          }
          if (this.getStepIndex('RECAP')) {
            this.annoncesFailedToSave.push(annonce)
          }
          if (error.response && error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.annonce[invalidField]['state'] = false
            this.annonce[invalidField]['invalidFeedback'] = i18n.t(error.response.data.message)

            if (invalidField === 'vehicleType') {
              this.goToStep('VEHICLE_TYPE')

            } else if (invalidField === 'brand') {
              this.goToStep('BRAND')

            } else if (invalidField === 'model') {
              this.goToStep('MODEL')

            } else if ((invalidField === 'vin' && !this.isLicensed) || ['licensePlate', 'bicycode', 'serialNumber', 'energy', 'color', 'address', 'firstnameOwner', 'lastnameOwner', 'identityRecto', 'identityVerso'].includes(invalidField)) {
              this.goToStep('MANDATORY_FIELDS')

            } else if (['annonceDescription', 'vin', 'hasWindowEngraving', 'fiscalPower'].includes(invalidField)) {
              this.goToStep('ADDITIONNAL_FIELDS')

            } else if (['imagesVehicleState', 'vehicleDescription'].includes(invalidField)) {
              this.goToStep('PHOTOS')

            } else if (['carteGriseFile', 'plainteFile', 'insuranceCompany', 'insuranceContract'].includes(invalidField)) {
              this.goToStep('PAPERS')

            } else {
              console.log("error.response", error.response)
            }
          }
        })
    },

    async saveDraft() {
      if (this.saved || this.notSaved) {
        return
      }
      await this.handleSubmit(true, true)
    },

    initAnnonce() {
      return {
        id: null,
        status: null,
        isFastAnnonce: this.isCreatingFastAnnonce,
        isLicensed: null,
        isComplete: false,
        needsReminderNotification: false,
        vehicleType: {state: null, invalidFeedback: null, value: null},
        brand: {state: null, invalidFeedback: null, value: null},
        model: {state: null, invalidFeedback: null, value: null},
        licensePlate: {state: null, invalidFeedback: null, value: null},
        licensePlateConfirm: {state: null, invalidFeedback: null, value: null},
        bicycode: {state: null, invalidFeedback: null, value: null},
        serialNumber: {state: null, invalidFeedback: null, value: null},
        energy: {state: null, invalidFeedback: null, value: null},
        color: {state: null, invalidFeedback: null, value: null},
        address: {state: null, invalidFeedback: null, value: null},
        isProprio: {state: null, invalidFeedback: null, value: null},
        identityRecto: {state: null, invalidFeedback: null, fileName: "", value: null},
        identityVerso: {state: null, invalidFeedback: null, fileName: "", value: null},
        hasWindowEngraving: {state: null, invalidFeedback: null, value: null},
        annonceDescription: {state: null, invalidFeedback: null, value: null},
        vin: {state: null, invalidFeedback: null, value: null},
        fiscalPower: {state: null, invalidFeedback: null, value: null},
        finitions: {state: null, invalidFeedback: null, value: null},
        vehicleDescription: {state: null, invalidFeedback: null, value: null},
        carteGriseFile: {state: null, invalidFeedback: null, value: null},
        assuranceFile: {state: null, invalidFeedback: null, value: null},
        plainteFile: {state: null, invalidFeedback: null, value: null},
        firstnameOwner: {state: null, invalidFeedback: null, value: null},
        lastnameOwner: {state: null, invalidFeedback: null, value: null},
        insuranceCompany: {state: null, invalidFeedback: null, value: null},
        insuranceContract: {state: null, invalidFeedback: null, value: null},
        imagesVehicleState: {state: null, invalidFeedback: null, value: null},
        vehicleFiles: [],
        additionnalRewardLevel: {state: null, invalidFeedback: null, value: null},
        additionnalRewardAmount: {state: null, invalidFeedback: null, value: null},
      };
    },

    setTotalToPay(total) {
      this.totalToPay = total
    },

    //region edit
    //Populating annonce from fetch (edit from show)
    async initAnnonceFetch(annonce) {
      this.skipReset = true;
      this.annonce = this.initAnnonce();
      this.isCreatingFastAnnonce = annonce.stepCreation.isFastAnnonce
      Vue.set(this.annonce.vehicleType, 'value', annonce.vehicle.vehicleTypeId);
      Vue.set(this.annonce, "isLicensed", annonce.vehicle.vehicleType.isLicensed);
      Vue.set(this.annonce, "isComplete", annonce.isComplete);
      Vue.set(this.annonce, "needsReminderNotification", annonce.needsReminderNotification);
      await this.fetchVehicleTypeInfo();
      Vue.set(this.annonce, 'id', annonce.id);
      Vue.set(this.annonce, 'status', annonce.status.value);
      Vue.set(this.annonce.brand, 'value', annonce.vehicle.brandId);
      Vue.set(this.annonce.model, 'value', annonce.vehicle.modelId);
      Vue.set(this.annonce.licensePlate, 'value', annonce.vehicle.licensePlate);
      if (!annonce.stepCreation.creationStep.step === "MANDATORY_FIELDS") {
        Vue.set(this.annonce.licensePlateConfirm, 'value', annonce.vehicle.licensePlate);
      }
      Vue.set(this.annonce.bicycode, 'value', annonce.vehicle.bicycode);
      Vue.set(this.annonce.serialNumber, 'value', annonce.vehicle.serialNumber);
      Vue.set(this.annonce.energy, 'value', annonce.vehicle.energy ? annonce.vehicle.energy.value : null);
      Vue.set(this.annonce.color, 'value', annonce.vehicle.color ? annonce.vehicle.color.value : null);
      Vue.set(this.annonce.address, 'value', annonce.vehicle.theftPosition.address);
      Vue.set(this.annonce.isProprio, 'value', annonce.isOwnedByCreator);
      Vue.set(this.annonce.hasWindowEngraving, 'value', annonce.vehicle.hasWindowEngraving);
      Vue.set(this.annonce.annonceDescription, 'value', annonce.description);
      Vue.set(this.annonce.vin, 'value', annonce.vehicle.vin);
      Vue.set(this.annonce.fiscalPower, 'value', annonce.vehicle.fiscalPower);
      Vue.set(this.annonce.finitions, 'value', annonce.vehicle.modelFinishId);
      Vue.set(this.annonce.vehicleDescription, 'value', annonce.vehicle.description);
      Vue.set(this.annonce.firstnameOwner, 'value', annonce.firstnameOwner);
      Vue.set(this.annonce.lastnameOwner, 'value', annonce.lastnameOwner);
      Vue.set(this.annonce, 'hasActiveStripeIntent', annonce.hasActiveStripeIntent);
      Vue.set(this.annonce, 'vehicleFiles', annonce.vehicle.vehicleImages.map(file => ({
        ...file,
        value: null,
        state: null,
        invalidFeedback: null
      })));

      if (annonce.vehicle.identityRectoFile) {
        Vue.set(this.annonce.identityRecto, 'fileName', annonce.vehicle.identityRectoFile.fileName);
        Vue.set(this.annonce.identityRecto, 'value', annonce.vehicle.identityRectoFile.value);
        Vue.set(this.annonce.identityRecto, 'state', annonce.vehicle.identityRectoFile.state);
        Vue.set(this.annonce.identityRecto, 'invalidFeedback', annonce.vehicle.identityRectoFile.invalidFeedback);
        Vue.set(this.annonce.identityRecto, 'fileUrl', annonce.vehicle.identityRectoFile.fileUrl);
        Vue.set(this.annonce.identityRecto, 'id', annonce.vehicle.identityRectoFile.id);
      }

      if (annonce.vehicle.identityVersoFile) {
        Vue.set(this.annonce.identityVerso, 'fileName', annonce.vehicle.identityVersoFile.fileName);
        Vue.set(this.annonce.identityVerso, 'value', annonce.vehicle.identityVersoFile.value);
        Vue.set(this.annonce.identityVerso, 'state', annonce.vehicle.identityVersoFile.state);
        Vue.set(this.annonce.identityVerso, 'invalidFeedback', annonce.vehicle.identityVersoFile.invalidFeedback);
        Vue.set(this.annonce.identityVerso, 'fileUrl', annonce.vehicle.identityVersoFile.fileUrl);
        Vue.set(this.annonce.identityVerso, 'id', annonce.vehicle.identityVersoFile.id);
      }

      if (annonce.vehicle.carteGriseFile) {
        Vue.set(this.annonce.carteGriseFile, 'fileName', annonce.vehicle.carteGriseFile.fileName);
        Vue.set(this.annonce.carteGriseFile, 'value', annonce.vehicle.carteGriseFile.value);
        Vue.set(this.annonce.carteGriseFile, 'state', annonce.vehicle.carteGriseFile.state);
        Vue.set(this.annonce.carteGriseFile, 'invalidFeedback', annonce.vehicle.carteGriseFile.invalidFeedback);
        Vue.set(this.annonce.carteGriseFile, 'fileUrl', annonce.vehicle.carteGriseFile.fileUrl);
        Vue.set(this.annonce.carteGriseFile, 'id', annonce.vehicle.carteGriseFile.id);
      }

      if (annonce.vehicle.depotPlainteFile) {
        Vue.set(this.annonce.plainteFile, 'fileName', annonce.vehicle.depotPlainteFile.fileName);
        Vue.set(this.annonce.plainteFile, 'value', annonce.vehicle.depotPlainteFile.value);
        Vue.set(this.annonce.plainteFile, 'state', annonce.vehicle.depotPlainteFile.state);
        Vue.set(this.annonce.plainteFile, 'invalidFeedback', annonce.vehicle.depotPlainteFile.invalidFeedback);
        Vue.set(this.annonce.plainteFile, 'fileUrl', annonce.vehicle.depotPlainteFile.fileUrl);
        Vue.set(this.annonce.plainteFile, 'id', annonce.vehicle.depotPlainteFile.id);
      }

      if (annonce.assuranceFile) {
        Vue.set(this.annonce.assuranceFile, 'fileName', annonce.assuranceFile.fileName);
        Vue.set(this.annonce.assuranceFile, 'value', annonce.assuranceFile.value);
        Vue.set(this.annonce.assuranceFile, 'state', annonce.assuranceFile.state);
        Vue.set(this.annonce.assuranceFile, 'fileUrl', annonce.assuranceFile.fileUrl);
        Vue.set(this.annonce.assuranceFile, 'id', annonce.assuranceFile.id);
        Vue.set(this.annonce.assuranceFile, 'invalidFeedback', annonce.assuranceFile.invalidFeedback);
      }

      Vue.set(this.annonce.insuranceCompany, 'value', annonce.vehicle.insuranceCompany);
      Vue.set(this.annonce.insuranceContract, 'value', annonce.vehicle.insuranceContract);
      Vue.set(this.annonce.additionnalRewardLevel, 'value', annonce.additionnalRewardLevel);
      Vue.set(this.annonce.additionnalRewardAmount, 'value', annonce.additionnalRewardAmount);
    },


    async fetchAnnonce() {
      await api
        .get(`/annonce/${this.annonceId}`)
        .then(async response => {
          this.annonceToEdit = response.data
          if (this.annonceToEdit.isDeleted) {
            this.$router.go(-1)
          }
          await this.initAnnonceFetch(this.annonceToEdit)
          if (this.annonceToEdit.stepCreation) {
            if (this.annonceToEdit.status.value === "DRAFT" && this.annonceToEdit.stepCreation.isFastAnnonce) {
              this.maxStep = AnnonceCreationUtils.fastAnnonceMaxStep(this.annonceToEdit)
              if (AnnonceCreationUtils.stepsToIgnoreInEdit().includes(this.annonceToEdit.stepCreation.creationStep.step)) {
                this.goToStep('MANDATORY_FIELDS')
              } else {
                this.goToStep(this.annonceToEdit.stepCreation.creationStep.step)
              }
            } else if (this.annonceToEdit.status.value === "DRAFT" && !this.annonceToEdit.stepCreation.isFastAnnonce) {
              this.maxStep = AnnonceCreationUtils.completeAnnonceMaxStep(this.annonceToEdit)
              if (AnnonceCreationUtils.stepsToIgnoreInEdit().includes(this.annonceToEdit.stepCreation.creationStep.step)) {
                this.goToStep('PAPERS')
              } else {
                this.goToStep(this.annonceToEdit.stepCreation.creationStep.step)
              }
            } else if (this.annonceToEdit.status.value === "REFUSED") {
              this.maxStep = AnnonceCreationUtils.completeAnnonceMaxStep(this.annonceToEdit)
              this.goToStep('VEHICLE_TYPE')
            } else if (this.annonceToEdit.status.value === "TO_VALIDATE") {
              this.isCreatingFastAnnonce = false
              this.lockPreviousButton = true
              this.maxStep = this.getStepIndex('PAPERS')
              this.goToStep('ADDITIONNAL_FIELDS')
            }
          }
        })
        .catch((error) => {

        })
    },
    //endregion
    //endregion

    //region recap
    removeAnnonce(index) {
      this.annonces.splice(index, 1);
    },

    ///Depuis le recap, fast ou complete
    isComplete(annonce) {
      if (annonce.isLicensed) {
        return (annonce.carteGriseFile.value !== null || (annonce.carteGriseFile.hasOwnProperty('id') && annonce.carteGriseFile.id)) && (annonce.plainteFile.value !== null || (annonce.plainteFile.hasOwnProperty('id') && annonce.plainteFile.id))
      } else {
        return (annonce.plainteFile.value !== null || (annonce.plainteFile.hasOwnProperty('id') && annonce.plainteFile.id))
      }
    },

    addNewAnnonce(creationType) {
      this.annonce = this.initAnnonce()
      this.maxStep = creationType === 'fast' ? AnnonceCreationUtils.fastAnnonceMaxStep(this.annonce) : AnnonceCreationUtils.completeAnnonceMaxStep(this.annonce)
      this.currentStep = this.getStepIndex('VEHICLE_TYPE')
      this.isCreatingFastAnnonce = (creationType === 'fast')
    },

    ///Ajout d'un brouillon au récap
    async addDraft(annonce) {
      this.skipReset = true;
      this.annonce = this.initAnnonce()
      this.annonce.isLicensed = annonce.isLicensed
      this.annonce.isComplete = annonce.isComplete
      this.annonce.vehicleType.value = annonce.vehicleType
      await this.fetchVehicleTypeInfo()
      this.annonce.id = annonce.id
      this.annonce.status = "DRAFT"
      this.annonce.brand.value = annonce.brand.value
      this.annonce.model.value = annonce.model.value
      this.annonce.licensePlate.value = annonce.licensePlate
      this.annonce.bicycode.value = annonce.bicycode
      this.annonce.serialNumber.value = annonce.serialNumber
      this.annonce.energy.value = annonce.energy
      this.annonce.color.value = annonce.color
      this.annonce.address.value = annonce.address
      this.annonce.isProprio.value = annonce.isProprio
      this.annonce.hasWindowEngraving.value = annonce.hasWindowEngraving
      this.annonce.annonceDescription.value = annonce.annonceDescription
      this.annonce.vin.value = annonce.vin
      this.annonce.fiscalPower.value = annonce.fiscalPower
      this.annonce.finitions.value = annonce.finitions
      this.annonce.vehicleDescription.value = annonce.vehicleDescription
      this.annonce.firstnameOwner.value = annonce.firstnameOwner
      this.annonce.lastnameOwner.value = annonce.lastnameOwner
      this.annonce.vehicleFiles = annonce.vehicleFiles.map(file => ({
        ...file,
        value: null,
        state: null,
        invalidFeedback: null
      }));
      this.annonce.identityRecto = {...this.annonce.identityRecto, ...annonce.identityRecto}
      this.annonce.identityVerso = {...this.annonce.identityVerso, ...annonce.identityVerso}
      this.annonce.carteGriseFile = {...this.annonce.carteGriseFile, ...annonce.carteGriseFile}
      this.annonce.plainteFile = {...this.annonce.plainteFile, ...annonce.plainteFile}
      this.annonce.assuranceFile = {...this.annonce.assuranceFile, ...annonce.assuranceFile}
      this.annonce.insuranceCompany.value = annonce.insuranceCompany
      this.annonce.insuranceContract.value = annonce.insuranceContract
      this.annonce.additionnalRewardLevel.value = annonce.additionnalRewardLevel
      this.annonce.additionnalRewardAmount.value = annonce.additionnalRewardAmount
      this.maxStep = annonce.isFastAnnonce ? AnnonceCreationUtils.fastAnnonceMaxStep(this.annonce) : AnnonceCreationUtils.completeAnnonceMaxStep(this.annonce)
      this.currentStep = this.getStepIndex('VEHICLE_TYPE')
      this.isCreatingFastAnnonce = annonce.isFastAnnonce
    },

    //Edit annonce depuis recap
    async editAnnonce(index) {
      this.skipReset = true;
      let id = Object.assign(JSON.parse(JSON.stringify(this.annonces))[index]).id
      this.annonce = this.annonces[index]
      await this.fetchVehicleTypeInfo()
      this.annonces.splice(index, 1)
      this.isCreatingFastAnnonce = this.annonce.isFastAnnonce
      this.maxStep = this.annonce.isFastAnnonce ? AnnonceCreationUtils.fastAnnonceMaxStep(this.annonce) : AnnonceCreationUtils.completeAnnonceMaxStep(this.annonce)
      this.currentStep = this.getStepIndex('VEHICLE_TYPE')
      Vue.set(this.annonce, 'id', id)
    },
    //endregion

    //region payment
    async requestStripePaymentIntent() {
      if (this.totalToPay > 0) {
        let formData = new FormData()
        formData.append('total', this.totalToPay)

        api({
          method: 'POST',
          url: `/annonce/createStripeIntentForBankImprint`,
          data: formData
        })
          .then((response) => {
            this.stripeIntentId = response.data.paymentIntentId
            this.stripeClientSecret = response.data.paymentIntentSecret
            this.$nextTick(() => {
              this.$bvModal.show('StripePaymentModal')
            })
          })
          .catch((error) => {
            this.handleError()
          })
      }
    },

    closedStripePaymentModal() {
      this.isLoading = false
      this.isPublishing = false
    },

    handlePostPaymentSuccess() {
      this.hasPaid = true

      let annoncesIds = this.annonces.filter(annonce => annonce.id).map(annonce => annonce.id).join(',')

      let data = new FormData()
      data.append('annonceIds', annoncesIds)
      data.append('paymentIntentId', this.stripeIntentId)


      api({
        method: "POST",
        url: `/annonce/validateStripeIntentForBankImprint`,
        data: data
      })
        .then((response) => {
          if (response.data === true) {
            this.$bvModal.show('annonce-online-modal')
          } else {
            this.handleError()
          }
        })
        .catch((error) => {
          this.handleError()
        })
    },

    handleError() {
      this.isLoading = false
      this.hasPaid = false
      this.isPublishing = false
      this.errorToast()
    },

    errorToast() {
      this.$bvToast.toast(this.$i18n.t('Error'), {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        variant: 'error',
        title: this.$i18n.t('Error.title'),
      })
    },

    //endregion
  }
}
</script>

<style scoped>
/* pour affichage desktop (md) : scroll pas sur la page entière mais sur le contenu modifiable uniquement */
@media (min-width: 769px) {

  #annonce-create-container {
    height: calc(89vh - 100px);
    max-height: calc(89vh - 100px);
  }

  #annonce-create-title-container {
    height: 100px;
  }

  #annonce-create-sub-container {
    height: calc(100% - 100px);
  }

  #annonce-create-sub-container-right {
    height: 100%;
  }
}

@media (max-width: 768px) {
  #annonce-create-sub-container-right {
    margin-bottom: 100px;
  }
}

.save-draft-icon-mobile {
  align-self: start;
  padding-top: 6px;
}

.active-draft {
  color: var(--main-green-medium);
}

.custom-span-data {
  display: none;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.2em;
  max-height: 3.6em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}

@media (min-width: 769px) {


  .custom-span-data {
    display: block;
    width: 33%;
    color: var(--main-grey-medium);
  }
}

.custom-width {
  width: 50%;
}

.col-title {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-create-annonce {
  background-color: var(--main-black-dark);
  position: fixed;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 100px;
  z-index: 10;
}

.fixed-bottom-100px {
  position: fixed;
  left: 0;
  bottom: 105px;
  z-index: 10;
  margin-left: 5em;
}


.span-step {
  color: var(--main-grey-medium);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.button-spinner.spinner-border {
  margin-left: calc(1.5rem + 28px - 0.5rem);
  margin-right: calc(1.5rem + 28px - 0.5rem);
}

@media (max-width: 768px) {

  .custom-width {
    width: 100%;
  }


  .col-title {
    display: flex;
    flex-direction: column;
    align-content: flex-start;
    justify-content: flex-start;
    align-items: flex-start;
  }

}
</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceCreate/AnnonceCreate.vue